import { render } from "./ReportEditor.vue?vue&type=template&id=37ebe0a0&scoped=true"
import script from "./ReportEditor.vue?vue&type=script&lang=js"
export * from "./ReportEditor.vue?vue&type=script&lang=js"

import "./ReportEditor.vue?vue&type=style&index=0&id=37ebe0a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ebe0a0"]])

export default __exports__